import React from 'react';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { TutorialPanelProps } from '@cloudscape-design/components';

export const TUTORIAL_STORAGE_KEY = 'finspace-tutorial-state';

export const HOTSPOT_IDS = {
  ASK_AI_BUTTON: 'ask-ai-button',
} as const;

export const AI_ASSISTANT_TUTORIAL_ID = 'ai-assistant-intro';

/** Modern Gen AI styled tutorial */
export const aiAssistantTutorial: TutorialPanelProps.Tutorial = {
  title: 'Meet Your AI Assistant',
  description: 'Your intelligent companion for FinSpace',
  completed: false,
  completedScreenDescription: "You're all set! Click Ask AI anytime to get help.",
  tasks: [
    {
      title: 'AI-Powered Assistance',
      steps: [
        {
          title: '✨ Ask AI Anything',
          content: (
            <SpaceBetween size="s">
              <Box variant="p">
                Click the <Box variant="strong" color="text-status-info">Ask AI</Box> button to open your personal AI assistant.
              </Box>
              <Box variant="small" color="text-body-secondary">
                Get instant answers, generate reports, analyze data, and more — all through natural conversation.
              </Box>
            </SpaceBetween>
          ),
          hotspotId: HOTSPOT_IDS.ASK_AI_BUTTON,
        },
      ],
    },
  ],
};
